import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { filter, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  generatedTokens: Record<string, string | undefined> = {};

  urlRetryCount: Record<string, number> = {};

  clearTokenTimeout: ReturnType<typeof setTimeout>;

  refreshInterval = 90 * 1000; // 60 seconds

  constructor(private readonly recaptchaV3Service: ReCaptchaV3Service) {}

  getUrlRetryCount(url: string) {
    return this.urlRetryCount[url] || 0;
  }

  retryingRequest(url: string): void {
    if (!this.urlRetryCount[url]) {
      this.urlRetryCount[url] = 0;
    }

    this.urlRetryCount[url] = this.urlRetryCount[url] + 1;
    this.regenerateToken(url);
  }

  resetUrlRetryCount(url: string): void {
    this.urlRetryCount[url] = 0;
  }

  getToken(url: string): Observable<string> {
    this.startTokenClearOutTimer(url);

    if (!this.generatedTokens[url]) {
      return this.recaptchaV3Service.execute('getToken').pipe(
        filter((token) => !!token),
        tap((token) => {
          this.generatedTokens[url] = token;
        })
      );
    }

    return of(this.generatedTokens[url]);
  }

  startTokenClearOutTimer(url: string) {
    if (this.clearTokenTimeout) {
      clearTimeout(this.clearTokenTimeout);
    }

    this.clearTokenTimeout = setTimeout(() => {
      this.generatedTokens[url] = undefined;
    }, this.refreshInterval);
  }

  regenerateToken(url: string): void {
    this.generatedTokens[url] = undefined;
  }
}
